import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router';
import useAppAbilities from '@/components/abilities';
import NotFound from '@/components/blocks/NotFound';
import { initialState, ViewType } from '../shared/useListReducer';
import OverallTraineeReportPage from './OverallTraineeReportPage';

const IndividualReportRoute = () => {
    const { assessmentRunId, userId, programId } = useParams<{
        assessmentRunId?: string;
        userId?: string;
        programId?: string;
    }>();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const abilities = useAppAbilities();
    const location = useLocation();

    const editMode = useMemo(() => searchParams.get('edit') === 'true', [searchParams]);

    const handleBack = useCallback(() => {
        const from = (location.state as { from?: string } | undefined)?.from;
        if (from) {
            void navigate(from);
            return;
        }
        // fallback to previous page
        if (window.history.length > 2) {
            void navigate(-1);
            return;
        }

        // else redirect to reports page
        void navigate('/reports/individual');
    }, [location.state, navigate]);

    if (!abilities.canViewReports()) {
        return <NotFound />;
    }

    if (!assessmentRunId || !userId) {
        return <NotFound />;
    }

    return (
        <OverallTraineeReportPage
            handleBack={handleBack}
            state={{
                ...initialState,
                viewType: ViewType.ShowReport,
                assessmentRunIdSelected: assessmentRunId,
                userIdSelected: userId,
                programIdSelected: programId,
                editMode: editMode,
            }}
        />
    );
};

export default IndividualReportRoute;
